var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2471(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_24-7_1_",
    "data-name": "24-7 (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3490",
    "data-name": "Path 3490",
    d: "M96.194,96.194A226.006,226.006,0,0,1,384.331,69.967l-28.977,2.972,3.061,29.843,78-8-8-78-29.844,3.061,2.594,25.291A256.021,256.021,0,0,0,43.563,398.9L68.441,382.13c-.345-.513-.68-1.03-1.021-1.545A226.044,226.044,0,0,1,96.194,96.194Z",
    fill: "#231c5f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3491",
    "data-name": "Path 3491",
    d: "M468.438,113.105,443.559,129.87c.345.512.68,1.031,1.021,1.545A226.012,226.012,0,0,1,127.669,442.033l28.977-2.972-3.061-29.843-78,8,8,78,29.844-3.061-2.594-25.291A256.022,256.022,0,0,0,468.438,113.1Z",
    fill: "#231c5f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3492",
    "data-name": "Path 3492",
    d: "M124.983,287.484l19.42-17.949c14.712-13.535,17.508-22.657,17.508-32.661,0-19.126-16.331-31.337-40.017-31.337-20.3,0-34.868,8.533-42.665,21.48l21.627,12.064a21.049,21.049,0,0,1,18.39-10c8.827,0,13.241,3.972,13.241,10.593,0,4.267-1.177,8.975-9.416,16.625L84.525,292.34v18.243h80.181v-23.1H124.983Z",
    fill: "#231c5f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3493",
    "data-name": "Path 3493",
    d: "M257.252,290.868h15.3v-23.1h-15.3V250.263H229.74V267.77H208.849L250.778,207.6h-30.16l-46.2,64.292v18.979h54.435v19.714h28.4Z",
    fill: "#231c5f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3494",
    "data-name": "Path 3494",
    d: "M299.038,325.294l48.549-138.588H322.724l-48.55,138.588Z",
    fill: "#231c5f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3495",
    "data-name": "Path 3495",
    d: "M372.3,246.584V230.7h27.07l-34.72,79.887h31.778l36.339-84.742V207.6H347.441v38.987Z",
    fill: "#231c5f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2471);
export default __webpack_public_path__ + "static/media/24-7 (1).e74ddaa9eb15cbd9c2c03280a8804383.svg";
export { ForwardRef as ReactComponent };